export const ONBOARDING_CREATE = `mutation onBoardingCreate($input: MerchantOnboardingCreateInput!){
    onboardingCreate(input:$input){
        onboarding {
            id
            metadata 
        }
    }
}`;
